import { createState } from "lexical";
import { z } from "zod";
import { isUUID } from "../../../../utils/uuid";

import type { UUID } from "../../../../utils/uuid";

const linkTargetSchema = z.object({
  type: z.enum(["link_lib", "link_email"]),
  id: z.custom<UUID>((value) => typeof value === "string" && isUUID(value)),
});

export type LinkTarget = z.infer<typeof linkTargetSchema>;

// Extra data stored on a link node when it was made from the Content Library or Email Communication
// tab of the link dialog: which tab, and the id of the file or communication picked. Editing the
// link reopens the dialog on that tab with that item chosen. Plain URL links store nothing.
// Uses Lexical's NodeState, which saves it inside the link node's JSON (under "$").
export const linkTargetState = createState("linkTarget", {
  parse: (value): LinkTarget | null => linkTargetSchema.safeParse(value).data ?? null,
});
